<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-button type="danger" size="mini" v-if="this.crowdConfigList.length>0" @click="handleModify" >修改</el-button>
                <el-button type="success" size="mini" v-else @click="handleAdd">新增</el-button>

            </el-form-item>
        </el-form>

        <el-table :data="crowdConfigList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
           <el-table-column type="index" label="序号" width="50"></el-table-column>
           <el-table-column prop="ruleDesc" label="首页众筹提示" width="800"></el-table-column>
           <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
           <el-table-column label="操作" fixed="right" width="400">
               <template slot-scope="scope">
                <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
               </template>
           </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>


        <!-- 众筹基本配置 -->
        <el-dialog title="众筹基本配置" :visible.sync="showDialog" center>
            <el-form :model="crowdConfig" label-width="120px">
                <el-form-item label="众筹首页配置id" v-show="false">
                    <el-input v-model="crowdConfig.id" placeholder="众筹首页配置id"></el-input>
                </el-form-item>
                <el-form-item label="首页众筹提示" prop="notice">
                    <el-input type="textarea" v-model="crowdConfig.ruleDesc" placeholder="首页众筹提示"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCrowdConfig()" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>

        <el-dialog title="图片管理" :visible.sync="dialogFormVisibleUpload" center append-to-body>
           <el-form :model="openUploadForm" label-width="120px">
               <el-form-item label="众筹主键">
                  <el-input v-model="openUploadForm.proId" placeholder="众筹主键" :disabled="true"></el-input>
               </el-form-item>
               <el-form-item label="图片类型" >
                   <el-select v-model="openUploadForm.typeId" clearable  placeholder="图片类型">
                       <el-option label="banner图" value="1"></el-option>
                       <el-option label="列表图" value="2"></el-option>
                       <el-option label="介绍图" value="3"></el-option>
                       <el-option label="介绍长图" value="4"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="图片众筹分类" >
                   <el-select v-model="openUploadForm.classId" clearable  placeholder="图片众筹分类">
                       <el-option label="众筹通用配置" value="1"></el-option>
                       <el-option label="众筹活动配置" value="2"></el-option>
                   </el-select>
               </el-form-item>

               <el-form-item label="上传图片">
                   <el-upload
                           multiple
                           :data="openUploadForm"
                           :with-credentials="true"
                           :show-file-list="false"
                           class="upload-demo"
                           :action="saveCrowdImagePath"
                           :on-success="uploadSuccess"
                           :before-upload="uploadBefore">
                       <el-button size="small" type="primary">点击上传</el-button>图片大小尽量不超过500k
                   </el-upload>
               </el-form-item>
           </el-form>

           <el-table :data="crowdPicList" stripe border center height="460">
               <el-table-column label="序号" type="index" width="60"></el-table-column>
               <el-table-column prop="id" label="图片" v-if='show' width="220"></el-table-column>
               <el-table-column prop="proId" label="众筹主键" v-if='show' width="220"></el-table-column>
               <el-table-column label="图片类型" :formatter="typeName" prop="type"></el-table-column>
               <el-table-column label="图片众筹分类" :formatter="classIdName" prop="classId"></el-table-column>
               <el-table-column label="图片展示">
                   <template slot-scope="scope">
                       <img :src="scope.row.picUrl" width="60" height="60" class="head_pic">
                   </template>
               </el-table-column>
               <el-table-column label="操作">
                   <template slot-scope="scope">
                       <el-button-group>
                           <el-button type="danger" size="mini" @click="deleCrowdPic(scope.row)">删除</el-button>
                       </el-button-group>
                   </template>
               </el-table-column>
           </el-table>
       </el-dialog>
    </div>
</template>

<script>
    import {getCrowdConfigInfo,saveCrowdConfigInfo,saveCrowdImage,getCrowdPicList,deleCrowdPicInfo} from '@/api/api';
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                crowdConfig:{
                    "id":"",
                    "ruleDesc":""
                },
                dialogFormVisibleUpload: false,
                openUploadForm: {
                    proId:"",
                    classId:"",
                    typeId: "",
                    imageName: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
                showDialog:false,
                loading: true,
                saveCrowdImagePath: saveCrowdImage,
                crowdConfigList:[],
                crowdPicList:[]
            }
        },

        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.handleCrowdConfigList();
        },

        methods: {
            handleCrowdConfigList(){
                this.loading = true;
                getCrowdConfigInfo(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.crowdConfigList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.handleCrowdConfigList();
            },

            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.handleCrowdConfigList();
            },
            handleAdd(){
                this.showDialog = true;
                this.crowdConfig.ruleDesc=this.crowdConfigList[0].ruleDesc;
                this.crowdConfig.id=this.crowdConfigList[0].id;
            },
            handleModify(){
                this.showDialog = true;
                this.crowdConfig.ruleDesc=this.crowdConfigList[0].ruleDesc;
                this.crowdConfig.id=this.crowdConfigList[0].id;
            },

            saveCrowdConfig(){
                saveCrowdConfigInfo(this.crowdConfig).then((res) => {
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.handleCrowdConfigList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handlePic(row){
                this.openUploadForm.proId = row.id;
                this.dialogFormVisibleUpload = true;
                this.handleCrowdPicList(row.id);
            },
            handleCrowdPicList(id){
                getCrowdPicList({proId:id}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.crowdPicList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            uploadBefore(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
            },
            uploadSuccess(res) {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                loading.close();
                if (res.status == 200) {
                    this.$notify({
                        title: '成功',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.handleCrowdPicList(this.openUploadForm.proId);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            },
            deleCrowdPic(row){
                this.$confirm('删除此数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleCrowdPicInfo({id:row.id}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.handleCrowdPicList(row.proId);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});

            },
            typeName(row, column, cellValue) {
                  if (row.type == 1) {
                    return "banner图";
                  } else if (row.type == 2) {
                    return "列表图";
                  }else if (row.type == 3) {
                     return "介绍图";
                  }else if (row.type == 4) {
                     return "介绍长图";
                  }else {
                     return "未知";
                  }
              },

              classIdName(row, column, cellValue) {
                  if (row.classId == 1) {
                      return "众筹通用配置";
                  } else if (row.classId == 2) {
                      return "众筹活动配置";
                  }else {
                      return "未知";
                  }
              }
        }
    }

</script>


// WEBPACK FOOTER //
// src/views/crowd/crowdConfigList.vue